import { useAuthContext } from '../../../contexts/AuthContext'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { TestSendForm, TestPageHeader } from '../../../components/alerts/TestSendForm'
import { alertsApi } from '../../../services/admin/alertsApi'
import { LocalStorageItem } from '../../../common/constants'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function DirectEmailTestPage() {
  const { email } = useAuthContext()
  return (
    <div className="space-y-6">
      <TestPageHeader
        mode="direct"
        title="Direct Email"
        subtitle={
          <>
            Bypasses the alerts pipeline. Calls SendGrid directly to verify the API key. From{' '}
            <span className="font-medium text-gray-700">no-reply@atcreate.ca</span>.
          </>
        }
      />

      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <TestSendForm
          mode="direct"
          recipientLabel="Recipient"
          recipientType="email"
          recipientPlaceholder="name@example.com"
          recipientRegex={EMAIL_REGEX}
          recipientInvalidMessage="Enter a valid email address."
          bodyRows={4}
          defaultBody={`This is a direct test email from the IoAg admin portal${email ? ` (by ${email})` : ''}.\n\nIf you received this, the SendGrid API key is configured correctly.`}
          storageKey={LocalStorageItem.adminTestEmailRecipient}
          buttonLabel="Send Test Email"
          buttonIcon={faEnvelope}
          bodyHelper="Plain text. Newlines are preserved."
          onSend={async (params) => {
            const r = await alertsApi.directEmail(params)
            return { recipient: r.recipient }
          }}
        />
      </section>
    </div>
  )
}
